<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fOeL8l/tc-custom/9783987448850.jpg?1704424884672" alt="This image is the cover for the book Bunner Sisters, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bunner Sisters, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Bunner Sisters, written in 1892 but not published until 1916 in Xingu and Other Stories, takes place in a shabby neighborhood in New York City. The two Bunner sisters, Ann Eliza the elder, and Evelina the younger, keep a small shop selling artificial flowers and small handsewn articles to Stuyvesant Square's "female population." Ann Eliza gives Evelina a clock for her birthday. The clock leads the sisters to become involved with Herbert Ramy, owner of "the queerest little store you ever laid eyes on." Soon Ramy is a regular guest of the Bunner sisters, who realize that their "treadmill routine," once so comfortable, is now "intolerably monotonous." Ramy's appearance also begins to distance the sisters from each other, as Ann Eliza notes pathetic signs of flirtation in Evelina. Ann Eliza decides to sacrifice her own hopes and yearnings for those of her younger sister.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edith Wharton
      </h2>
      
      <p class="authorDescription body article">Edith Wharton (born Edith Newbold Jones; January 24, 1862 – August 11, 1937) was an American novelist, short story writer, and interior designer. Wharton drew upon her insider's knowledge of the upper class New York "aristocracy" to realistically portray the lives and morals of the Gilded Age. In 1921, she became the first woman to win the Pulitzer Prize in Literature, for her novel The Age of Innocence. She was inducted into the National Women's Hall of Fame in 1996. Among her other well known works are The House of Mirth and the novella Ethan Frome.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?866511a2